import { apiClient } from '@/lib/api/client'

export interface AnalyticsOverview {
  summary: {
    total_users: number
    total_pages: number
    total_media: number
    total_categories: number
    total_tags: number
  }
  user_metrics: {
    total: number
    active: number
    new_today: number
    new_this_week: number
    new_this_month: number
    new_last_30_days: number
  }
  content_metrics: {
    total_pages: number
    published_pages: number
    draft_pages: number
    pages_this_month: number
  }
  activity_metrics: {
    total: number
    today: number
    this_week: number
    by_module: Record<string, number>
    by_action: Record<string, number>
  }
  trends: {
    user_registration: {
      labels: string[]
      data: number[]
    }
    page_creation: {
      labels: string[]
      data: number[]
    }
  }
}

export const analyticsService = {
  async getOverview(): Promise<AnalyticsOverview> {
    const response = await apiClient.get('/analytics/overview')
    return response.data.data
  },
}

